module.exports = __webpack_public_path__ + "static/img/daily-img1.f287e77.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/daily-img1.png
// module id = HPEs
// module chunks = 1